export default __webpack_public_path__ + "static/media/clock.56fa2614.svg";